import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { combineLatest, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppService } from '../../services/app.service';
import { LayoutService } from '../../services/layout.service';

@Component({
    selector: 'u4-cpp-layout',
    templateUrl: './layout.component.html'
})
export class LayoutComponent implements OnInit, OnDestroy {

    @ViewChild('canvas', {static: true}) canvas;
    visible: boolean;
    layoutClass: string;
    destroy$: Subject<void> = new Subject();

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private appService: AppService,
        private layoutService: LayoutService
    ) {
        combineLatest([this.appService.isReady, this.layoutService.loaded$]).subscribe(([appReady, layoutReady]) => {
            this.visible = appReady && layoutReady;
        });
    }


    ngOnInit() {
        this.layoutClass = this.getLayoutClass();

        this.router.events.pipe(
            takeUntil(this.destroy$)
        ).subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.layoutClass = this.getLayoutClass();
            }
        });

        // When a new notification is posted, scroll to the top of the canvas
        this.appService.notification.pipe(
            takeUntil(this.destroy$)
        ).subscribe(() => {
            window.scroll(0, 0);
        });
    }

    componentLoaded(component: string) {
        this.layoutService.setLoaded(component);
    }

    getLayoutClass(): string {
        let layoutType = '';
        let route = this.route;

        while (route) {
            const layoutData = route.snapshot.data.layout as string;
            if (layoutData && typeof layoutData === 'string') {
                layoutType = layoutData;
            }
            route = route.firstChild;
        }

        return layoutType === 'fullWidth' ? 'cpp-layout--full-width' : '';
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

}
